import './apexcharts-init';
import PropTypes from 'prop-types';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

if (typeof window !== 'undefined') {
  window.process = window.process || { env: { NODE_ENV: process.env.NODE_ENV || 'development' } };
  window.PropTypes = PropTypes;
}

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<App/>);